import { lowercase } from '../../shared/display'

const getChunkedRawBody = async (req) => {
  if (req?.rawBody) {
    return req.rawBody
  }

  // TODO: move to req.text() after next 13.5: https://github.com/vercel/next.js/discussions/13405
  try {
    const _getRawBody = (await import('raw-body')).default

    if (!req.method || (lowercase(req.method) === 'get')) {
      return undefined
    }

    return _getRawBody(req).then((_rawBody) => _rawBody?.toString())
  } catch (error) {
    console.error(`Failed to import 'raw-body', please ensure the dependency is installed`)
    throw error
  }
}

// TODO: explore returning mutated request object adding on req.rawBody??
export const ensureRawBody = async (req) => (
  getChunkedRawBody(req)
    .catch((error) => {
      console.error(`Error getting raw body for '${req?.url}'`, error)
      throw error
  })
)
